let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("gC8Nc")).then(() => parcelRequire('dsFIi'));